import { Link } from 'react-router-dom';
import { Alert, Card, Icon } from '../../components/ui';
import { useAuth } from '../../lib/auth';
import { usePageMeta } from '../../lib/seo';
import { tr } from '../../lib/i18n';

export function PanelSupportPage(): JSX.Element {
  usePageMeta(tr('Suporte'), tr('Canais de ajuda da AgendaPro e documentos legais.'), '/painel/suporte');
  const { active } = useAuth();

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl">{tr("Suporte")}</h1>
        <p className="text-sm text-muted">{tr("Como obter ajuda com o painel e onde encontrar as políticas.")}</p>
      </div>

      <Alert tone="info" title={tr("Sobre os canais de atendimento")}>
        {tr("A AgendaPro ainda não disponibiliza, para o painel do profissional, uma rota que consulte automaticamente o e-mail ou o WhatsApp oficiais de suporte. Por isso esta tela não simula a abertura de chamados: use os canais públicos abaixo, que são a referência oficial de contato.")}
      </Alert>

      <div className="grid gap-4 md:grid-cols-2">
        <Card as="section">
          <div className="mb-2 flex items-center gap-2 text-lg font-semibold"><Icon name="info" /> {tr("Central de ajuda")}</div>
          <p className="mb-3 text-sm text-muted">{tr("Perguntas frequentes e guias de uso do painel, agenda e planos.")}</p>
          <div className="flex flex-wrap gap-2">
            <Link to="/faq" className="nl-btn nl-btn-secondary">{tr("Perguntas frequentes")}</Link>
            <Link to="/suporte" className="nl-btn nl-btn-secondary">{tr("Página de suporte")}</Link>
            <Link to="/contato" className="nl-btn nl-btn-secondary">{tr("Fale conosco")}</Link>
          </div>
        </Card>

        <Card as="section">
          <div className="mb-2 flex items-center gap-2 text-lg font-semibold"><Icon name="whatsapp" /> {tr("WhatsApp do seu negócio")}</div>
          <p className="mb-3 text-sm text-muted">
            {active
              ? tr('O botão de WhatsApp exibido aos seus clientes usa o número cadastrado no seu estabelecimento.')
              : tr('Nenhum estabelecimento ativo selecionado.')}
          </p>
          <div className="flex flex-wrap gap-2">
            <Link to="/painel/perfil" className="nl-btn nl-btn-secondary">{tr("Configurar WhatsApp do perfil")}</Link>
            <Link to="/painel/configuracoes" className="nl-btn nl-btn-secondary">{tr("Configurações")}</Link>
          </div>
        </Card>

        <Card as="section">
          <div className="mb-2 flex items-center gap-2 text-lg font-semibold"><Icon name="settings" /> {tr("Faturamento e plano")}</div>
          <p className="mb-3 text-sm text-muted">{tr("Dúvidas sobre teste gratuito, cobrança ou cancelamento? Comece pela tela Meu plano, que mostra o estado real da assinatura e das transações.")}</p>
          <Link to="/painel/plano" className="nl-btn nl-btn-primary">{tr("Ir para Meu plano")}</Link>
        </Card>

        <Card as="section">
          <div className="mb-2 flex items-center gap-2 text-lg font-semibold"><Icon name="shield" /> {tr("Documentos legais")}</div>
          <p className="mb-3 text-sm text-muted">{tr("Termos de uso e política de privacidade da plataforma.")}</p>
          <div className="flex flex-wrap gap-2">
            <Link to="/termos" className="nl-btn nl-btn-secondary">{tr("Termos de uso")}</Link>
            <Link to="/privacidade" className="nl-btn nl-btn-secondary">{tr("Política de privacidade")}</Link>
            <Link to="/cancelamento" className="nl-btn nl-btn-secondary">{tr("Política de cancelamento")}</Link>
          </div>
        </Card>
      </div>
    </div>
  );
}
